/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Unread_ItemInputs */

const en_bell_unread_item = /** @type {(inputs: Bell_Unread_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Bell_Unread_ItemInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_unread_item = /** @type {((inputs?: Bell_Unread_ItemInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Unread_ItemInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_unread_item(inputs)
});